import axiosInstance from "./AxiosInstance";

export function createBillApi(data){
    return axiosInstance.post('/api/billings',data)
}

export function updateBillApi(id,data){
    return axiosInstance.patch(`/api/billings/${id}`,data)
}

export function verifyVehicleNumberApi(number){
    return axiosInstance.get(`api/vehicles/details/?numbers=${number}`)
}

export function getBillsApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/billings?${fparam}`)
}

export function getBillDeatilsApi(id){
    return axiosInstance.get(`api/billings/${id}`)
}
export function getBillExportApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/billings?${fparam}`, {
    responseType: "blob",
  });
}